import React, { useEffect, useState } from "react";
import {
  fetchEducationDetail,
  fetchEducationStart,
  fetchEducationArchiveStart,
} from "../../actions/education";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { t } from "i18next"; // Import t function for translation
import { formatDateFull } from "../../utils";

const Education = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { educationDetail } = useSelector((state) => state.educationReducer);
  const [cooldownSeconds, setCooldownSeconds] = useState(null);

  useEffect(() => {
    if (!educationDetail?.cooldownEnd) return;

    const [h, m, s] = educationDetail.cooldownEnd.split(":").map(Number);
    const totalSeconds = h * 3600 + m * 60 + s;
    setCooldownSeconds(totalSeconds);
  }, [educationDetail?.cooldownEnd]);

  useEffect(() => {
    if (cooldownSeconds === null || cooldownSeconds <= 0) return;

    const interval = setInterval(() => {
      setCooldownSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [cooldownSeconds]);

  const formatCooldownTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}:${m.toString().padStart(2, "0")}:${s
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    dispatch(fetchEducationDetail(id));
  }, [id, dispatch]);

  const startEducation = () => {
    dispatch(fetchEducationStart(id, navigate, educationDetail?.video));
  };

  const startArchiveEducation = () => {
    dispatch(fetchEducationArchiveStart(id, navigate, educationDetail?.video));
  };

  return (
    <div className="education-detail-main-container">
      <div className="education-detail-content">
        <Breadcrumb
          title={t("education.breadcrumb.education_and_trainings")}
          returnPage="/education-list"
        />

        <div className="education-list-main-item">
          <div className="education-main-item-content-title">
            {educationDetail?.name}
          </div>
          <div className="education-main-item-image">
            <img src={educationDetail?.image} className="img-fluid" alt="LG" />
          </div>
          <div className="education-main-item-content">
            <div className="education-main-item-center-text">
              <div className="education-main-item-content-time">
                <img
                  src="/images/clock-icon.png"
                  className="img-fluid"
                  alt="LG"
                />{" "}
                {educationDetail?.duration}
              </div>
              <div className="education-main-item-content-points">
                <img
                  src="/images/star-icon.png"
                  className="img-fluid"
                  alt="LG"
                />{" "}
                {educationDetail?.points} {t("education.points")}
              </div>
            </div>
            <div
              className="education-main-item-content-description"
              dangerouslySetInnerHTML={{ __html: educationDetail?.description }}
            ></div>
            {!educationDetail?.isFinish && (
              <div className="education-main-item-content-button">
                <div
                  className="education-main-item-content-button-item"
                  onClick={startEducation}
                >
                  {t("education.start_training")}
                </div>
              </div>
            )}
            {(educationDetail?.isFinish ||
              educationDetail?.status === "archive") && (
              <div className="education-main-item-content-button">
                <div
                  className="education-main-item-content-button-item"
                  onClick={startArchiveEducation}
                >
                  {t("education.start_archive_training")}
                </div>
              </div>
            )}
            {cooldownSeconds !== null &&
              cooldownSeconds > 0 &&
              !educationDetail?.isFinish && (
                <div className="education-main-item-content-cooldown">
                  {t("trainingAgain")}:<br />
                  <b>{formatCooldownTime(cooldownSeconds)}</b>
                </div>
              )}
          </div>
          <div className="education-main-item-points"></div>
        </div>
      </div>
    </div>
  );
};

export default Education;
